<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Admin Guideline</button>
                    </div>
                </div>
                  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name [(ngModel)]="searchVal" (keydown.enter)="filter(searchVal)" />
                        <button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1" >
                        <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          (click)="openModal(myModal,'','')" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [count]="page.totalPages" ></ngx-datatable>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [count]="page.totalPages" [externalPaging]="true">
                
                <ngx-datatable-column name="Key" prop="key" [width]="190">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
						<div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
							<div class="avatar-content">
							  {{ row?.key | shortName }}
							</div>
						  </div>
                      <div class="cell-line-height cursor-pointer">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.key }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Value" prop="value" [width]="60">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      
                      <div class="cell-line-height cursor-pointer">
                        <!-- <p *ngIf="selected_datatype !='richtext'" class="font-medium-1 line-height-1 mb-0">
                          {{ row?.value }}
                        </p>
                        <p *ngIf="selected_datatype =='richtext'" class="font-medium-1 line-height-1 mb-0">
                          <span [innerHTML]="stripHtmlTags(row?.value)"></span>
                        </p> -->
                        <!-- <div class="font-medium-1 line-height-1">{{stripHtmlTags(row?.value)}}</div> -->
                        <div (click)="openValue(myModalValue,row)">
                          Link
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Data Type" prop="data_type" [width]="30">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      {{row?.data_type }}
                  </ng-template>
                </ngx-datatable-column>
				<ngx-datatable-column name="Notes" prop="notes" [width]="80">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					   <p [innerText]="row?.notes"></p>
					</ng-template>
				  </ngx-datatable-column>
				  <ngx-datatable-column name="Admin Notes" prop="admin_notes" [width]="80">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p [innerText]="row?.admin_notes"></p>
					</ng-template>
				  </ngx-datatable-column>
                <ngx-datatable-column name="Action " [width]="10">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex action-box">
						<span> <i class="ft-edit text-primary cursor-pointer" (click)="openModal(myModal,row?._id,row)"></i> </span>
						<span> <i class="ft-trash text-danger cursor-pointer" (click)="confirmDelete(row?._id)"></i> </span>
					</div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
    </div>
  <!--------------  Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="!row_id">Add Setting</h4>
			<h4 class="modal-title" *ngIf="row_id">Update Setting</h4>

			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<label>Key</label>
					<input type="text" placeholder="Enter key" class="form-control" [(ngModel)]="setting_model.key" [ngModelOptions]="{standalone: true}">
				</div>
        <div class="form-group">
					<label>Data Type</label>
            <ng-select
              [items]="dataType_list"
              bindLabel="name"
              bindValue="_id"
              [closeOnSelect]="true"
              placeholder="Select Datatype"
              [(ngModel)]="selected_datatype"
              [ngModelOptions]="{ standalone: true }"
              (change)="getDatatypeId($event)"
            ></ng-select>
				</div>
				<div class="form-group" *ngIf="selected_datatype !='richtext'">
					<label>Value <span *ngIf="setting_model.key==='stats'" placement="right" ngbTooltip="eg. [ {'label':'label1','value':1},{'label':'label2','value':2} ]"><i class="ft-info text-primary"></i></span>
            <span *ngIf="setting_model.key==='hot-links'" placement="right" ngbTooltip="eg. [ {'linkName':'linkName1','url':'urlValue1'},{'linkName':'linkName2','url':'urlValue2'} ]"><i class="ft-info text-primary"></i></span>
            <span *ngIf="setting_model.key==='general-announcement' || setting_model.key==='warning-message'" placement="right" ngbTooltip="eg. [ {'description':'descriptionValue'} ]"><i class="ft-info text-primary"></i></span>
            <span *ngIf="setting_model.key==='quick-links'" placement="right" ngbTooltip="eg. {'linkName':'linkNameValue1'}"><i class="ft-info text-primary"></i></span>
            <span *ngIf="setting_model.key==='guideline-section7'" placement="right" ngbTooltip="eg. {'title':'titleValue','name':'nameValue','description':'descriptionValue','link':'linkValue'}"><i class="ft-info text-primary"></i></span>
            <span *ngIf="setting_model.key==='section8'" placement="right" ngbTooltip="eg.  [ {'label':'labelValue','id':'1'} ]"><i class="ft-info text-primary"></i></span>
          </label> 
          <textarea *ngIf="selected_datatype =='text'" name="value" id="value" placeholder="Enter value" class="form-control" [(ngModel)]="setting_model.value" [ngModelOptions]="{standalone: true}" cols="30" rows="4" ></textarea>
					<!-- <input *ngIf="selected_datatype =='text'" type="text" placeholder="Enter value" class="form-control" [(ngModel)]="setting_model.value" [ngModelOptions]="{standalone: true}"> -->
          <input *ngIf="selected_datatype =='number'" type="number" placeholder="Enter value" class="form-control" [(ngModel)]="setting_model.value" [ngModelOptions]="{standalone: true}">
          <input *ngIf="selected_datatype =='date'" type="date" placeholder="Enter value" class="form-control" [(ngModel)]="setting_model.value" [ngModelOptions]="{standalone: true}">
          
				</div>
				<div *ngIf="selected_datatype =='richtext'" class="form-group">
          <label>Value</label>
          <quill-editor (onContentChanged)="setFocus($event)" [(ngModel)]="setting_model.value" [ngModelOptions]="{standalone: true}"></quill-editor>
        </div>
				<div class="form-group">
					<label>Notes</label>
					<textarea name="notes"placeholder="Enter notes" id="notes" cols="30" rows="3" class="form-control" [(ngModel)]="setting_model.notes" [ngModelOptions]="{standalone: true}"></textarea>
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<textarea name="admin_notes" placeholder="Enter admin notes" id="admin_notes" cols="30" rows="3" class="form-control" [(ngModel)]="setting_model.admin_notes" [ngModelOptions]="{standalone: true}"></textarea>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>

		  </div>
	</ng-template>
</div>
<!-------------- Value  Popup ------------------------------------------->
<div>
  <ng-template #myModalValue let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{setting_data.key}}'s Value</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="edit-icon">
        <i class="ft-edit text-primary" (click)="isEdit()"></i>
      </div>
      <div *ngIf="setting_data.data_type !='richtext'">
        <p  *ngIf="!isupdate_value">{{setting_data.value}}</p>
        <div *ngIf="isupdate_value">
          <input type="text" class="form-control" [(ngModel)]="setting_data.value" [ngModelOptions]="{standalone: true}" >
        </div>
      </div>
      <div *ngIf="setting_data.data_type =='richtext'" class="text-editor-box">
        <p *ngIf="!isupdate_value" [innerHTML]="setting_data.value"></p>
        <quill-editor *ngIf="isupdate_value" (onContentChanged)="setFocus($event)" [(ngModel)]="setting_data.value" [ngModelOptions]="{standalone: true}"></quill-editor>
      </div>
    </div>
    <div class="modal-footer">
      <button *ngIf="isupdate_value" type="button" class="btn btn-primary" (click)="updateValue()">Update</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>

